import { api } from './api';

class VendorLocationsAdminService {
  async listVendors({ page = 1, limit = 50, search = '', is_active = true } = {}) {
    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('limit', String(limit));
    if (search) params.set('search', search);
    if (is_active !== undefined && is_active !== null) params.set('is_active', String(is_active));
    return api.get(`/api/admin/vendors?${params.toString()}`);
  }

  async getVendorLocations(vendorId, { is_active } = {}) {
    const params = new URLSearchParams();
    if (is_active !== undefined && is_active !== null) params.set('is_active', String(is_active));
    const qs = params.toString();
    return api.get(`/api/admin/vendors/${vendorId}/locations${qs ? `?${qs}` : ''}`);
  }

  async updateVendorLocation(locationId, patch) {
    return api.put(`/api/admin/vendor-locations/${locationId}`, patch);
  }
}

export const vendorLocationsAdminService = new VendorLocationsAdminService();

